import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const ExpandingTextarea = ({
  value,
  onChange,
  rows: initialRows,
  maxRows,
  className,
}) => {
  const [rows, setRows] = useState(initialRows);
  const textareaContainer = useRef(null);

  const onUpdate = ({ target }) => {
    const lines = target.value.split('\n').length;
    let newRows = lines;
    newRows = lines > maxRows ? maxRows : newRows;
    newRows = lines < initialRows ? initialRows : newRows;

    setRows(newRows);
    onChange(target.value);
  };

  useEffect(() => {
    if (textareaContainer) {
      textareaContainer.current.focus();
    }
  }, [textareaContainer]);

  return (
    <textarea
      value={value}
      onChange={onUpdate}
      ref={textareaContainer}
      rows={rows}
      className={className}
    />
  );
};

ExpandingTextarea.propTypes = {
  rows: PropTypes.number,
  maxRows: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

ExpandingTextarea.defaultProps = {
  rows: 3,
  maxRows: null,
  value: '',
  onChange: () => {},
  className: '',
};

export default ExpandingTextarea;
